import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { ListItemCreateRequest } from '../../Models/Models';
import { SiteContext } from '../../Contexts';
import { EntityColors } from '../../Themes/EntityColors';
import SaveButton from '../Buttons/SaveButton';
import DiscardButton from '../Buttons/DiscardButton';
import { Utils } from '../../Services/Utils';
import { ListItemService } from '../../Services/ListItemService';
import FormShell from '../Form/FormShell';
import RequiredLabel from "../Form/RequiredLabel";
import CharCount from '../Form/CharCount';
import { FieldLengths } from '../../Models/FieldLengths';
import { useIsDirty } from '../../Hooks/useIsDirty';

const ListItemCreateComponent = () => {
    useEffect(() => {
        Utils.setDocumentTitle('Pridanie položky zoznamu');
    }, []);

    const { action, icon } = EntityColors.list;
    const { createListItem } = ListItemService();
    const { currentSite }: any = useContext(SiteContext);
    const { listId } = useParams();

    const [listItem, setListItem] = useState<ListItemCreateRequest>({ listId: Number(listId), text: '' });
    const isDirty = useIsDirty(listItem, true);

    const doSave = async () => {
        await createListItem(listItem);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        void doSave();
    };

    return (
        <FormShell title="Pridať položku zoznamu" icon={icon} accentColor={action} backHref="/list/table" isDirty={isDirty}>
            <form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <div className="st-field-head">
                        <RequiredLabel>Text</RequiredLabel>
                        <CharCount value={listItem.text} max={FieldLengths.listItemText} />
                    </div>
                    <Form.Control
                        required
                        autoFocus
                        maxLength={FieldLengths.listItemText}
                        value={listItem.text}
                        onChange={e => setListItem({ ...listItem, text: e.target.value })}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <div className="st-field-head">
                        <Form.Label>Odkaz</Form.Label>
                        <CharCount value={listItem.link} max={FieldLengths.listItemLink} />
                    </div>
                    <Form.Control
                        type="url"
                        placeholder="(nepovinné) napr. https://example.sk"
                        maxLength={FieldLengths.listItemLink}
                        value={listItem.link}
                        onChange={e => setListItem({ ...listItem, link: e.target.value })}
                    />
                </Form.Group>

                <div className="d-flex justify-content-center mt-4 gap-3">
                    <DiscardButton to="/list/table" isDirty={isDirty} />
                    <SaveButton type="submit" onSave={doSave} websiteId={currentSite.id} />
                </div>
            </form>
        </FormShell>
    );
};

export default ListItemCreateComponent;
